module.exports = __webpack_public_path__ + "img/user.2ca23960.jpg";